import { render, staticRenderFns } from "./BuyMembership.vue?vue&type=template&id=6087041b"
import script from "./BuyMembership.vue?vue&type=script&lang=ts"
export * from "./BuyMembership.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports